import PropTypes from "prop-types";
import PromotionCodeContainer from "app/pages/Booking/PromotionCode/PromotionCodeContainer";
import { FormattedMessage } from "react-intl";
import { PAYMENT_COUPON_TYPE } from "app/constants";
import "./PromotionCodeRadio.scss";
import RadioFormik from "app/pages/.shared/form/RadioFormik";

const PromotionCodeRadio = ({
	onChange = () => {},
	onValidPromoCodeApplied,
	onPromoCodeFocus = () => {},
	couponType,
}) => {
	const isChecked = couponType === PAYMENT_COUPON_TYPE.PROMOCODE;

	const checked = {
		value: isChecked,
		shouldCheckTheValue: true,
	};

	return (
		<RadioFormik
			showIcon={true}
			name="promo-code-radio"
			id="promo-code-radio"
			value={PAYMENT_COUPON_TYPE.PROMOCODE}
			body={
				<div className="promotion-code-radio__body">
					<PromotionCodeContainer
						onValidPromoCodeApplied={onValidPromoCodeApplied}
						onFocus={onPromoCodeFocus}
					/>
				</div>
			}
			checked={checked}
			toggle={() => {
				if (!isChecked) {
					onChange(PAYMENT_COUPON_TYPE.PROMOCODE);
				}
			}}
			data-testid={`coupon-promocode-input`}
		>
			<div className="promotion-code-radio__content">
				<div className="promotion-code-radio__name">
					<FormattedMessage id="payment.coupons.input.promocode.label" />
				</div>
			</div>
		</RadioFormik>
	);
};

PromotionCodeRadio.propTypes = {
	onChange: PropTypes.func,
	onValidPromoCodeApplied: PropTypes.func,
	onPromoCodeFocus: PropTypes.func,
	couponType: PropTypes.string,
};

export default PromotionCodeRadio;
